import { yupResolver } from '@hookform/resolvers/yup'
import React, { useContext, useRef, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Controller, useForm } from 'react-hook-form'
import { registerFormschema } from '../../../util/validationSchema'
import { Link, useNavigate } from 'react-router-dom' //useNavigate
import { useDispatch } from 'react-redux'
import { userRegistration } from '../../../redux/slices/authSlice' //userFacebookLogin, userGoogleLogin
import { PROJECT_TITLE } from '../../../util/constant'
import { MainLogo } from '../../../helper/imagepath' //Facebook, Googgle, HorizontalLine
// import { Button } from 'reactstrap'
import { errorToast, successToast } from '../../../util/Toast/toast'
import { SpinnerContext } from '../../../context/spinnerContext'
// import CustomModal from '../../../component/customModal'
// import VerifyEmail from '../../../component/verifyEmail'
// import { useGoogleLogin } from '@react-oauth/google'
// import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
// import axios from 'axios'
import InputMask from 'react-input-mask'
import { capitalizeFirstLetter, formatPhoneNumbertoString } from '../../../helper/function'
import { StandaloneSearchBox, useLoadScript } from '@react-google-maps/api'

const Register = () => {
  const { changeLoader } = useContext(SpinnerContext)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const inputRef = useRef(null)
  const {
    handleSubmit,
    control,
    trigger,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(registerFormschema)
  })

  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  // const [showVerifyEmailModal, setShowVerifyEmailModal] = useState(false)
  // const [verificationEmail, setVerificationEmail] = useState(null)

  // const toggleVerifyEmailModal = () => setShowVerifyEmailModal(!showVerifyEmailModal)
  const onPasswordEyeClick = () => setShowPassword(!showPassword)
  const onConfirmPasswordEyeClick = () => setShowConfirmPassword(!showConfirmPassword)

  const onSubmit = (data) => {
    if (data) {
      // setVerificationEmail(data?.email)
      const payload = {
        ...data,
        contact_no: formatPhoneNumbertoString(data?.contact_no)
      }
      changeLoader(true)
      dispatch(userRegistration(payload)).then(({ payload }) => {
        if (payload?.status === 200) {
          // toggleVerifyEmailModal()
          successToast(payload?.data?.status_message || 'Register successfully')
          changeLoader(false)
          navigate('/login')
        } else {
          errorToast(payload?.data?.status_message || 'Something went wrong')
          changeLoader(false)
        }
      })
    }
  }

  // Load Google Maps script

  const { isLoaded } = useLoadScript({
    id: 'google-map-script',
    // eslint-disable-next-line no-undef
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    libraries: ['places']
  })

  const handlePlacesChanged = (onChange) => {
    const places = inputRef.current.getPlaces()
    if (places.length > 0) {
      const place = places[0]
      const address = place.formatted_address // Full formatted address

      // Update form field and log coordinates (if needed)
      onChange(address)
    }
  }

  // const handleAuthResponse = async (data, serviceLogin) => {
  //   try {
  //     const { payload } = await dispatch(serviceLogin(data))
  //     if (payload?.status === 200) {
  //       navigate('/')
  //       successToast(payload?.data?.status_message || 'Success!')
  //     } else {
  //       errorToast(payload?.data?.status_message || 'Something went wrong')
  //     }
  //   } catch (error) {
  //     errorToast('An unexpected error occurred')
  //     console.error(error)
  //   } finally {
  //     changeLoader(false)
  //   }
  // }

  // const login = useGoogleLogin({
  //   onSuccess: async (tokenResponse) => {
  //     changeLoader(true)
  //     try {
  //       const { data } = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
  //         headers: { Authorization: `Bearer ${tokenResponse.access_token}` }
  //       })

  //       const payload = {
  //         google_id: data.sub,
  //         full_name: data.name,
  //         email: data.email
  //       }
  //       handleAuthResponse(payload, userGoogleLogin)
  //     } catch (error) {
  //       errorToast('Error fetching user information')
  //       console.error(error)
  //       changeLoader(false)
  //     }
  //   },
  //   onError: (error) => {
  //     errorToast('Google login failed')
  //     console.error(error)
  //   }
  // })

  // const handleFacebookResponse = (response) => {
  //   if (response.status !== 'unknown') {
  //     changeLoader(true)
  //     const payload = {
  //       facebook_id: response.id,
  //       full_name: response.name,
  //       email: response.email
  //     }
  //     handleAuthResponse(payload, userFacebookLogin)
  //   } else {
  //     errorToast('Facebook login failed')
  //     console.error('Facebook login failed')
  //   }
  // }

  return (
    <>
      <Helmet>
        <title>{PROJECT_TITLE}</title>
        {/* <link rel="icon" href={''}></link> */}
      </Helmet>
      <div className="alert alert-info notification-alert mb-0">
        For quality assurance we can’t schedule your first cleaning with less than 72 hours. If you need a last minute cleaning for your first
        cleaning, please call us at (415) 900-0313.
      </div>
      <div className="auth-wrapper-main">
        <div className="container ">
          <div className="authbox">
            <div className="auth-left">
              <div className="auth-page-title d-flex">
                Register to{' '}
                <img
                  // className="img-fluid logo-dark"
                  src={MainLogo}
                  onError={(event) => {
                    event.target.src = MainLogo
                  }}
                  alt="Logo"
                />
              </div>

              <div className="auth-form-content">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="row">
                    <div className="col-lg-6 col-12">
                      <div className="form-group input_text">
                        <label className="form-control-label">First Name</label> <span className="text-danger">*</span>
                        <Controller
                          name="first_name"
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <input
                              className={`form-control  ${errors?.first_name ? 'error-input' : ''}`}
                              type="text"
                              value={value || ''}
                              autoComplete="false"
                              placeholder="Enter First Name"
                              onChange={(val) => {
                                const input = val.target.value
                                const capitalized = capitalizeFirstLetter(input)
                                onChange(capitalized)
                                trigger('first_name')
                              }}
                            />
                          )}
                        />
                        <small>{errors?.first_name?.message}</small>
                      </div>
                    </div>
                    <div className="col-lg-6 col-12">
                      <div className="form-group input_text">
                        <label className="form-control-label">Last Name</label> <span className="text-danger">*</span>
                        <Controller
                          name="last_name"
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <input
                              className={`form-control  ${errors?.last_name ? 'error-input' : ''}`}
                              type="text"
                              value={value || ''}
                              onChange={(val) => {
                                const input = val.target.value
                                const capitalized = capitalizeFirstLetter(input)
                                onChange(capitalized)
                                trigger('last_name')
                              }}
                              autoComplete="false"
                              placeholder="Enter Last Name"
                              // ref={emailRem}
                            />
                          )}
                        />
                        <small>{errors?.last_name?.message}</small>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 col-12">
                      <div className="form-group input_text">
                        <label className="form-control-label">Email</label> <span className="text-danger">*</span>
                        <Controller
                          name="email"
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <input
                              className={`form-control  ${errors?.email ? 'error-input' : ''}`}
                              type="text"
                              value={value || ''}
                              onChange={(val) => {
                                onChange(val)
                                trigger('email')
                              }}
                              autoComplete="false"
                              placeholder="Enter Email Address"
                              // ref={emailRem}
                            />
                          )}
                        />
                        <small>{errors?.email?.message}</small>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 col-12">
                      <div className="form-group input_text">
                        <label>
                          Phone Number <span className="text-danger">*</span>
                        </label>
                        <Controller
                          name="contact_no"
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <InputMask
                              mask="(999) 999-9999" // Mask format
                              value={value}
                              onChange={(val) => {
                                onChange(val)
                                trigger('contact_no')
                              }}
                              className={`form-control ${errors?.contact_no ? 'error-input' : ''}`}
                              placeholder="Enter Phone Number"
                              autoComplete="off"
                            >
                              {(inputProps) => <input {...inputProps} />}
                            </InputMask>
                          )}
                          defaultValue=""
                        />
                        <small>{errors?.contact_no?.message}</small>
                      </div>
                    </div>
                  </div>
                  <div className="row mb-1">
                    <div className="col-lg-12 col-12">
                      <div className="form-group input_text">
                        <label>Address</label>
                        <Controller
                          name="personal_address"
                          control={control}
                          rules={{ required: 'Address is required' }}
                          render={({ field: { onChange } }) => (
                            <>
                              {isLoaded ? (
                                <StandaloneSearchBox onLoad={(ref) => (inputRef.current = ref)} onPlacesChanged={() => handlePlacesChanged(onChange)}>
                                  <input
                                    className="form-control"
                                    type="text"
                                    placeholder="Enter Address"
                                    onChange={(e) => onChange(e.target.value)}
                                  />
                                </StandaloneSearchBox>
                              ) : null}
                            </>
                          )}
                        />
                        <small className="text-danger">{errors?.personal_address?.message}</small>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 col-12">
                      <div className="form-group input_text">
                        <label className="form-control-label">Password</label> <span className="text-danger">*</span>
                        <Controller
                          name="password"
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <div className="pass-group">
                              <input
                                type={showPassword ? 'text' : 'password'}
                                className={`form-control  ${errors?.password ? 'error-input' : ''}`}
                                value={value}
                                onChange={(val) => {
                                  onChange(val)
                                  trigger('password')
                                }}
                                autoComplete="false"
                                placeholder="Enter Password"
                                onCopy={(e) => e.preventDefault()} // Disable copy
                                onCut={(e) => e.preventDefault()} // Disable cut
                              />
                              <span onClick={onPasswordEyeClick} className={`fa toggle-password ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`} />
                            </div>
                          )}
                          defaultValue=""
                        />
                        <small>{errors?.password?.message}</small>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 col-12">
                      <div className="form-group input_text">
                        <label className="form-control-label">Confirm Password</label> <span className="text-danger">*</span>
                        <Controller
                          name="confirmPassword"
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <div className="pass-group">
                              <input
                                type={showConfirmPassword ? 'text' : 'password'}
                                className={`form-control  ${errors?.confirmPassword ? 'error-input' : ''}`}
                                value={value}
                                onChange={(val) => {
                                  onChange(val)
                                  trigger('confirmPassword')
                                }}
                                autoComplete="false"
                                placeholder="Enter Confirm Password"
                                onCopy={(e) => e.preventDefault()} // Disable copy
                                onPaste={(e) => e.preventDefault()} // Disable paste
                                onCut={(e) => e.preventDefault()} // Disable cut
                              />
                              <span
                                onClick={onConfirmPasswordEyeClick}
                                className={`fa toggle-password ${showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                              />
                            </div>
                          )}
                          defaultValue=""
                        />
                        <small>{errors?.confirmPassword?.message}</small>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-12 col-12">
                      <div className="form-group input_text">
                        <Controller
                          name="is_term_accepted"
                          control={control}
                          render={({ field: { onChange, value } }) => (
                            <>
                              <label className="d-flex align-items-center">
                                <input
                                  className="custom-checkbox m-0"
                                  type="checkbox"
                                  checked={value}
                                  onChange={(e) => {
                                    onChange(e.target.checked)
                                    trigger('is_term_accepted')
                                  }}
                                />
                                <span className="dont-have" style={{ marginLeft: 15, color: 'black' }}>
                                  I accept the{' '}
                                  <a
                                    href="https://sett.solutions/terms-and-conditions"
                                    className="termConditions"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    Terms and Conditions
                                  </a>
                                  , including policies on cancellations, service limits, and liability, by signing up.
                                </span>
                              </label>
                              <small>{errors?.is_term_accepted?.message}</small>
                            </>
                          )}
                        />
                      </div>
                    </div>
                  </div>
                  <button className="btn btn-lg btn-block w-100 btn-primary w-100" type="submit">
                    Register
                  </button>
                </form>
                {/* <div className={`social_div`}>
                  <div className="divider_div">
                    <img src={HorizontalLine} width={155} height={1} alt="logo" />
                    <p className="common_para text-center mx-3">Or</p>
                    <img src={HorizontalLine} width={155} height={1} alt="logo" />
                  </div>
                  <div className="social_btn_main_div">
                    <FacebookLogin
                      // eslint-disable-next-line no-undef
                      appId={`${process.env.REACT_APP_FACEBOOK_APP_ID}`}
                      autoLoad={false}
                      fields="name,email,picture"
                      callback={handleFacebookResponse}
                      render={(renderProps) => (
                        <Button className="btn btn-primary paid-cancel-btn w-100 mb-3 auth-social-btn" onClick={renderProps.onClick}>
                          <img src={Facebook} alt="icon" /> <span>Continue With Facebook</span>
                        </Button>
                      )}
                    />
                    <Button className="btn btn-primary paid-cancel-btn w-100 mb-3 auth-social-btn" onClick={() => login()}>
                      <img src={Googgle} alt="icon" /> <span>Continue With Google</span>
                    </Button>
                    <AppleLogin
                      clientId="YOUR_APPLE_CLIENT_ID"
                      redirectURI="YOUR_APPLE_REDIRECT_URI"
                      responseType="code"
                      responseMode="query"
                      usePopup={true}
                      callback={handleAppleResponse}
                      render={(renderProps) => (
                        <Button className="btn btn-primary paid-cancel-btn w-100 mb-3 auth-social-btn" onClick={renderProps?.onClick}>
                          <img src={Apple} alt="icon" /> <span>Continue With Apple</span>
                        </Button>
                      )}
                      onSuccess={handleAppleResponse}
                      onFailure={handleError}
                    />
                  </div>
                </div> */}

                <div className="text-center dont-have mt-3" style={{ color: '#252525CC' }}>
                  {`Already have an account?`} <Link to="/login">Login</Link>
                </div>
              </div>
            </div>

            {/* <div className="auth-right auth-register-bg-img"></div> */}
          </div>
        </div>
      </div>

      {/* {showVerifyEmailModal && (
        <CustomModal isOpen={showVerifyEmailModal} toggle={toggleVerifyEmailModal} isTitle={false}>
          <VerifyEmail verificationEmail={verificationEmail} toggleVerifyEmailModal={toggleVerifyEmailModal} />
        </CustomModal>
      )} */}
    </>
  )
}

export default Register
